import Button, { NavigableButton } from '@carvana/ds-button';
import { type IconProps } from '@carvana/ds-icons';
import { icon } from '@carvana/ds-styles';
import Clickable from '@carvana/merch-components/Clickable';
import { ChevronRight } from 'lucide-react';
import React from 'react';
import { useIsDesktop } from '~/context/common/DeviceContext';
import { DesktopCard, TabletCard } from './Card.styles';

type OwnProps = {
  action: string | ((ev: React.MouseEvent<HTMLElement>) => void);
  desktop: {
    cta: string;
    heading: string;
    subHeading: string;
  };
  tablet: {
    icon: (_: IconProps) => React.ReactElement;
    text: string;
  };
  testId?: string;
};

function TabletCardContents(props: OwnProps) {
  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-center gap-lg">
      <props.tablet.icon color={icon.inverse} size={48} />
      <p>{props.tablet.text}</p>
      <ChevronRight color={icon.inverse} size={24} />
    </div>
  );
}

export default function Card(props: OwnProps) {
  const isDesktop = useIsDesktop();
  const { action } = props;

  return isDesktop ? (
    <DesktopCard>
      <h2 className="t-heading-lg">{props.desktop.heading}</h2>
      <div className="row-span-2">
        {typeof action === 'string' ? (
          <NavigableButton
            variant="primaryInverted"
            size="sm"
            href={action}
            data-analytics-id="Hero CTA"
            data-testid={props.testId}
            data-analytics-attributes={{ text: props.desktop.cta }}
          >
            {props.desktop.cta}
          </NavigableButton>
        ) : (
          <Button
            variant="primaryInverted"
            size="sm"
            onClick={action}
            data-analytics-id="Hero CTA"
            data-testid={props.testId}
            data-analytics-attributes={{ text: props.desktop.cta }}
          >
            {props.desktop.cta}
          </Button>
        )}
      </div>
      <p className="t-body-sm">{props.desktop.subHeading}</p>
    </DesktopCard>
  ) : (
    <TabletCard>
      {typeof action === 'string' ? (
        <a
          href={action}
          className="block"
          data-analytics-id="Hero CTA"
          data-testid={props.testId}
          data-analytics-attributes={{ text: props.tablet.text }}
        >
          <TabletCardContents {...props} />
        </a>
      ) : (
        <Clickable
          onClick={action}
          data-analytics-id="Hero CTA"
          data-testid={props.testId}
          data-analytics-attributes={{ text: props.tablet.text }}
        >
          <TabletCardContents {...props} />
        </Clickable>
      )}
    </TabletCard>
  );
}
